import { ApiError, createAction } from 'redux-api-middleware';
import { HTTP_GET, HTTP_DELETE } from './ApiAction';
import { State as StoreState } from '../types/State';

export type UserInfo = {
  id: string;
  title: string;
  subtitle: string;
  content: string;
};

export const LOAD_USER_INFO = 'barmer-bonus-shared/user-info/LOAD' as const;
export const LOAD_USER_INFO_SUCCESS = 'barmer-bonus-shared/user-info/LOAD_SUCCESS' as const;
export const LOAD_USER_INFO_FAILURE = 'barmer-bonus-shared/user-info/LOAD_FAILURE' as const;

export const DISMISS_USER_INFO = 'barmer-bonus-shared/user-info/DISMISS' as const;
export const DISMISS_USER_INFO_SUCCESS = 'barmer-bonus-shared/user-info/DISMISS_SUCCESS' as const;
export const DISMISS_USER_INFO_FAILURE = 'barmer-bonus-shared/user-info/DISMISS_FAILURE' as const;

type LoadUserInfo = { type: typeof LOAD_USER_INFO };
type LoadUserInfoSuccess = { type: typeof LOAD_USER_INFO_SUCCESS; payload: UserInfo[] };
type LoadUserInfoFailure = { type: typeof LOAD_USER_INFO_FAILURE; payload: ApiError };

type DismissUserInfo = { type: typeof DISMISS_USER_INFO; payload: UserInfo['id'] };
type DismissUserInfoSuccess = { type: typeof DISMISS_USER_INFO_SUCCESS };
type DismissUserInfoFailure = { type: typeof DISMISS_USER_INFO_FAILURE; payload: ApiError };

export type Action =
  | LoadUserInfo
  | LoadUserInfoSuccess
  | LoadUserInfoFailure
  | DismissUserInfo
  | DismissUserInfoSuccess
  | DismissUserInfoFailure;

export type State = {
  loading: boolean;
  userInfo: UserInfo[] | null;
  error?: ApiError;
};

const initialState: State = {
  loading: false,
  userInfo: null,
};

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case LOAD_USER_INFO:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case LOAD_USER_INFO_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };
    case LOAD_USER_INFO_FAILURE:
      return {
        userInfo: null,
        loading: false,
        error: action.payload,
      };
    case DISMISS_USER_INFO:
      if (state.userInfo === null) {
        return state;
      }

      return {
        ...state,
        userInfo: state.userInfo.filter(({ id }) => id !== action.payload),
      };
    default:
      return state;
  }
}

export function isLoaded(globalState: StoreState) {
  return globalState.userInfo.userInfo !== null;
}

export function isLoading(globalState: StoreState) {
  return globalState.userInfo.loading;
}

export const loadUserInfo = (refresh = false) =>
  createAction({
    endpoint: '/user-info',
    types: [LOAD_USER_INFO, LOAD_USER_INFO_SUCCESS, LOAD_USER_INFO_FAILURE],
    method: HTTP_GET,
    bailout: (state: StoreState) => (!refresh && isLoaded(state)) || isLoading(state),
  });

export const dismissUserInfo = (id: UserInfo['id']) =>
  createAction({
    endpoint: `/user-info/${id}`,
    types: [
      { type: DISMISS_USER_INFO, payload: id },
      DISMISS_USER_INFO_SUCCESS,
      DISMISS_USER_INFO_FAILURE,
    ],
    method: HTTP_DELETE,
  });
